<!-- Botão flutuante -->
<div class="floating-filter-button" (click)="toggleFiltro()">
    <i class='bx bx-filter-alt'></i>
</div>

<!-- Painel de filtros -->
<div class="floating-filter-panel" [class.active]="filtroAberto">
    <div class="filter-header">
    <h5>{{ title }}</h5>
    <button class="btn-close" (click)="toggleFiltro()"></button>
    </div>
    <div class="filter-body">
    <div class="col-12">
        <!-- Conteúdo dinâmico do filtro -->
        <ng-content></ng-content>
        
        <!-- Botões de ação -->
        <div class="row mt-4">
        <div class="col-sm-12 col-md-12 col-lg-12 text-center">            
            <button (click)="aplicarFiltro()" class="btn btn-danger w-100" type="button">
            {{ searchButtonText }}
            </button>     
        </div>
        </div>
        <div class="row mt-2">
        <div class="col-sm-12 col-md-12 col-lg-12 text-center">            
            <button (click)="limparFiltro()" class="btn btn-secondary w-100" type="button">
            {{ clearButtonText }}
            </button>     
        </div>
        </div>
    </div>
    </div>
</div>